import Api, {ApiCall, ApiRequest} from "@/lib/Api";

export default {
    state : {
        Brands : [],
    },
    actions : {
        async switch_brands({dispatch}, id) {
            const res = await ApiRequest(ApiCall(Api.SwitchBrands, id));
            if (res.error) return dispatch('setError', res.error)
            dispatch('setSuccess', 'Successfully Switched Brands')
        },
        async duplicate_brand({dispatch, commit}, {id, name}) {
            const res = await ApiRequest(ApiCall(Api.DuplicateBrand, {name}, id));
            if (res.error) return dispatch('setError', res.error)
            if (res.brand) commit('save_brands', [res.brand, null])
            dispatch('setSuccess', 'Brand duplicated successfully')
            return res
        },
    },
    mutations : {

    }
}
